var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("v-data-table", {
        attrs: {
          items: _vm.revenueSourceList,
          headers: _vm.headers,
          loading: _vm.revenueSourceGetting
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function({ item }) {
              return [
                _c("tr", [
                  _c("td", [_vm._v(_vm._s(item.code))]),
                  _c("td", [_vm._v(_vm._s(item.description))]),
                  _c(
                    "td",
                    [
                      _c(
                        "base-tooltip",
                        {
                          attrs: {
                            color: "yellow darken-3",
                            small: "",
                            text: "",
                            tooltip: "edit",
                            dark: "",
                            bottom: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.editRevenueSource(item)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-pencil")])],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }